import React, { useEffect, useState, useRef }from "react";
import { Modal, Form, Input, Checkbox, notification } from "antd";
import _ from 'lodash';
import UserGrid from "../UserManager/UserGrid";

const UserSelectModal = ({ open, closeDialog, groupFilter, afterClose, onOk, loading }) => {
  
  const gridRef = useRef(null);
  
  return (
    <Modal
      open={open}
      onOk={() => onOk(gridRef.current.getSelectedUsers())}
      onCancel={closeDialog}
      width="900px"
      height={600}
      styles={{
        footer: {
          position: 'absolute',
          bottom: '25px',
          right: '25px'
        }
      }}
      title={`Add Selected Users`}
      forceRender={false}
      afterClose={afterClose}
      confirmLoading={loading}
      destroyOnClose={true}
      maskClosable={false}
      getContainer="#container"
    >
      <UserGrid
        ref={gridRef}
        size="small"
        groupFilter={groupFilter}
      />
    </Modal>
  );
};

export default UserSelectModal;
